import { isEqual } from 'lodash';

import { Dates } from 'context/DateProvider/DateProvider';

const normalizeDate = (date: Date) => {
  const normalizedDate = new Date(date);
  normalizedDate.setSeconds(0, 0);
  return normalizedDate;
};

const isNewSelectedDate = (selectedDate: Date[], dates: Dates) => {
  const currentFrom = normalizeDate(new Date(dates.from));
  const currentTo = normalizeDate(new Date(dates.to));
  const selectedFrom = normalizeDate(selectedDate[0]);
  const selectedTo = normalizeDate(selectedDate[1]);
  return !isEqual([selectedFrom, selectedTo], [currentFrom, currentTo]);
};

export const handleOnDateTimeRangeAccept =
  (dates: Dates, setDates: (dates: Dates) => void) => (selectedDate: Date[] | null) => {
    if (selectedDate !== null && isNewSelectedDate(selectedDate, dates)) {
      setDates({
        ...dates,
        from: selectedDate[0].toISOString(),
        to: selectedDate[1].toISOString(),
      });
    }
  };
